var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { aggregateAction, actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
import * as _ from "lodash";
import mdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ConfigPathActions = class {
  loadRootPath(workspaceId) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        dispatch(this.loadingRootPath());
        yield dispatch(this.loadedRootPath(workspaceId));
      });
      return inner;
    });
  }
  loadingRootPath() {
  }
  loadedRootPath(workspaceId) {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.getExperimentationGroupRootPath(workspaceId);
    });
  }
  getPaths(workspaceId) {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.getPaths(workspaceId);
    });
  }
  getAllPaths(workspaceId) {
    return __async(this, null, function* () {
      let response = yield Promise.all([
        mdsDataplaneResource.getPaths(workspaceId),
        mdsDataplaneResource.getPaths(workspaceId, true)
      ]);
      const activePaths = response[0];
      const allPaths = response[1];
      const allPathObjects = allPaths.map((p) => {
        return {
          path: p,
          isHidden: !_.includes(activePaths, p)
        };
      });
      return allPathObjects;
    });
  }
  selectPath(workspaceId, path) {
    return __async(this, null, function* () {
      const egId = getExperimentationGroupIdFromPath(workspaceId, path);
      return { selectedPath: path, experimentationGroupId: egId };
    });
  }
  selectDiffPath(path) {
    return path;
  }
  setIsHidden(workspaceId, path, isHidden) {
    return __async(this, null, function* () {
      const egId = getExperimentationGroupIdFromPath(workspaceId, path);
      yield mdsDataplaneResource.setIsHidden(workspaceId, egId);
      const normalizedPath = /^\//.test(path) ? path : "/" + path;
      return { path: normalizedPath, isHidden };
    });
  }
};
__decorateClass([
  aggregateAction()
], ConfigPathActions.prototype, "loadRootPath", 1);
ConfigPathActions = __decorateClass([
  actionClass("admin_app_module")
], ConfigPathActions);
const configPathActions = new ConfigPathActions();
export {
  ConfigPathActions,
  configPathActions as default
};
//# sourceMappingURL=ConfigPathActions.js.map
